
  import { Component, Ref, Vue } from 'vue-property-decorator';
  import { Action } from 'vuex-class';

  import Generic from '../../types/app/generic/generic';
  import Endpoint from '../../utils/endpoint';

  @Component({})
  export default class EntityType extends Vue {
    endpoint = new Endpoint();
    @Action('setSnackbar', { namespace: 'app' }) setSnackbar!: any;

    valid = null;
    saving = false;
    loading = false;
    rules = [
      v => !!v || 'This field is required'
      //v => (v && v.length <= 10) || 'Name must be less than 10 characters'
    ];
    isCreate = true;

    entityType: Generic = {
      name: '',
      shortName: '',
      active: true
    };

    async created() {
      this.isCreate = !this.$route.params.id;
      if (!this.isCreate) {
        this.loading = true;
        await this.getEntityType();
      }
    }

    get title(): string {
      return this.isCreate ? 'Create Entity Type' : 'Entity Type Detail';
    }

    async getEntityType(): Promise<void> {
      this.loading = true;
      const response = await this.$http.get(`${this.endpoint.entityType.getById}/${this.$route.params.id}`);

      if (response.status == 200) {
        this.entityType = response.data.data;
        this.loading = false;
      }
    }

    async save(): Promise<void> {
      if ((this.$refs.form as Vue & { validate: () => boolean }).validate()) {
        if (this.isCreate) {
          await this.create();
        } else {
          await this.update();
        }
      }
    }

    async update(): Promise<void> {
      this.saving = true;

      const response = await this.$http.put(
        `${this.endpoint.entityType.update}/${this.$route.params.id}`,
        this.entityType
      );

      if (response.status == 200) {
        this.saving = false;

        this.setSnackbar({
          show: true,
          message: 'Entity Type update',
          color: 'success'
        });

        this.$router.push({ name: 'IndexEntityType' });
      } else {
        this.saving = false;
        console.log('erro...', response);
      }
    }

    async create(): Promise<void> {
      this.saving = true;

      const response = await this.$http.post(this.endpoint.entityType.create, this.entityType);

      if (response.status == 200) {
        this.saving = false;

        this.setSnackbar({
          show: true,
          message: 'Entity Type saved',
          color: 'success'
        });

        this.$router.push({ name: 'IndexEntityType' });
      }

      if (response.status != 200) {
        this.saving = false;
      }
    }
  }
